import { pickBy } from "ramda";

export const objectFilter = <T>(
  obj: Record<string, T>,
  predicate: (obj: T) => boolean,
): Record<string, T> => {
  return pickBy(predicate, obj);
};
